
export type VoteOnPoll200OptionsItem = {
  optionId?: string;
  percentage?: number;
  text?: string;
  votes?: number;
};
